export default {
	headers: [
		{
			text: 'ID projet',
			align: 'left',
			value: 'projectKey',
			rule: 'project_edit'
		},
		{
			text: 'Nom du projet',
			align: 'left',
			value: 'name'
		},
		{
			text: 'Territoire',
			align: 'left',
			value: 'geographicalContext'
		},
		{
			text: 'Date de dernière modification',
			align: 'left',
			value: 'updatedAt',
			rule: 'project_edit',
			cellType: 'date'
		},
		{
			text: 'Date de fin',
			align: 'left',
			value: 'endDate',
			cellType: 'date'
		},
		{
			align: 'left',
			sortable: false,
			value: 'action'
		}
	],
	nbRowText: '0 projet | 1 projet | {count} projets',
	deleteDialogTitle: 'Êtes vous sûr de vouloir supprimer le projet ?',
	successDeleteMessage: 'Le projet a été supprimé avec succès',
	updateTitle: 'Modifier le projet',
	addTitle: 'Créer un projet'
};
